import React from 'react';
import { connect } from 'react-redux';
import { getInitialData } from '../../actions/index'
import { bindActionCreators } from 'redux';
import Chart from './component/Chart';
import NoDataFound from '../commonComponents/NoDataFound'

var labelShow = []

class ChartData extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...props };
        if (!props.metricValue)
            this.props.getInitialData(props.dataSet, props.chartCat, props.authData);

        this.timeHandle = this.timeHandle.bind(this);
    }    
    timeHandle(name, date) {
        var chartType = this.props.chartType;
        if (this.props.granularity == "date" || this.props.granularity == "hour") 
            var timeGran = [
                {
                    label: 'Hour',
                    value: 'Hour'
                }, {
                    label: 'Day',
                    value: 'Day'
                }, {
                    label: 'Week',
                    value: 'Week'
                }, {
                    label: 'Month',
                    value: 'Month'
                }, {
                    label: 'Quarter',
                    value: 'Quarter'
                }, {
                    label: 'Year',
                    value: 'Year'
                }
            ];
        else if (this.props.granularity == "month") 
            var timeGran = [
                {
                    label: 'Month',
                    value: 'Month'
                }, {
                    label: 'Quarter',
                    value: 'Quarter'
                }, {
                    label: 'Year',
                    value: 'Year'
                }
            ];
        else if (this.props.granularity == "year") 
            var timeGran = [
                {
                    label: 'Year',
                    value: 'Year'
                }
            ];
        var current = chartType;
        var gran = handleGran(timeGran, current);        
        if (gran) {
            date = getDate(date, gran, this.state.startDate);
            if(current == 'Year' && fiscalMonth)
                date = getFiscalDate(date.startDate, date.endDate, fiscalMonth);            
            chartType = getNextGran(current.toLowerCase(), true);
            if (this.state.property && this.state.property.split(',').length > 1) {
                var objBreak = breakUpget(this.state, name);
            } else {
                objBreak = {
                    "SelectedBreakUp": this.props.SelectedBreakUp,
                    "SelectedBreakUpDisp": this.props.SelectedBreakUpDisp
                };
            }
            
            var updateObj = {
                chartType: chartType,
                startDate: date.startDate,
                endDate: date.endDate,
                SelectedBreakUp: objBreak.SelectedBreakUp,
                SelectedBreakUpDisp: objBreak.SelectedBreakUpDisp
            };
            filterHandleChangeFunction(updateObj)
        }
    }
    render() {
        // if (!this.state.metricValue) {
        //     return null;
        // }

        let chartDispStyle = this.props.period ? "timeseries" : "nontimeseries";

        // var dashboard_config = setDashboardConfigFromJson(this.props.property, this.props.metricValue, this.props.period, this.props.chartCat, this.props.dashboardConfig, this.props.dataSet.userDBSetting[0].color);
        // var statusValid = dashboard_config.status
        // dashboard_config = dashboard_config.dashboard_config

        let status;

        if (this.props.chartCat === "Map" && this.props.geoLocationDimesnionArray == null) {
            status = { "valid": false, "message": `Geographical dimension  selection is required.Ask your admin to configure Geographical dimensions.` };
        } else if (this.props?.metricValue) {
            status = validationInput(
                this.props?.property,
                this.props?.metricValue,
                this.props?.period || "",
                this.props?.chartCat.toLowerCase(),
                "all"
            );
        } else {
            status = { "valid": false, "message": "Configuration not available" };
        }
        
        var dashboard_config = status?.style ? status?.style : this.props?.dashboardConfig
        dashboard_config['colorArray'] = typeof this.props.dashboardConfig['colorArray'] == "string" ? JSON.parse(this.props.dashboardConfig['colorArray']) : this.props.dashboardConfig['colorArray'];
        dashboard_config['colorArray'] = dashboard_config['colorArray'] && dashboard_config['colorArray'].length>0 ? dashboard_config['colorArray'] : JSON.parse(this.props.dataSet.userDBSetting[0].color);
        dashboard_config['labelOverlap'] = this.props.dataLabelOverlap;

        var chartType = this.props.chartType;
        var chartCat = this.props.chartCat && this.props.chartCat.toLowerCase() == "xrange" ? this.props.chartCat : this.props.chartCat;

        chartType = getPeriodBasedOnDates(this.props.startDate, this.props.endDate, chartType, this.props.chartCat, this.props.question)

        if (this.state.selectedMetricDisp && this.state.selectedMetricDisp.length>0) { 
            labelShow = getLabel(this.props.selectedMetricDisp, this.props.metricValue, this.props.propertyDisp, this.props.SelectedBreakUpDisp, this.state.insightType, this.state.insightMetric, this.props.includeDisp, this.props.excludeDisp);
        }            
        else
            labelShow = {
                'metricText': null,
                'propertyText': null,
                'breakupText': null
            };
        
        if (status?.valid) {
            return (
                <Chart
                    dataLabelConfig={this.props.dataLabelConfig}
                    yAxis= {this.props.yAxis}
                    dataSet = {this.props.dataSet}
                    authData={this.props.authData}
                    startDate={this.props.startDate}
                    mapType={this.props.mapType}
                    endDate={this.props.endDate}
                    category={this.props.property}
                    propertyDisp={this.props.propertyDisp}
                    categoryValue={this.props.SelectedCategoryValue}
                    metric={this.props.metricValue}
                    breakUp={this.props.SelectedBreakUp}
                    include={this.props.include}
                    exclude={this.props.exclude}
                    chartType={chartType=="Aggregate" ? null : chartType}
                    chartDispStyle={chartDispStyle}
                    analysis={this.props.analysis}
                    regressionLine={this.props.regressionLine}
                    clusterCount={this.props.clusterCount}
                    initial={this.props.initial}
                    drill={this.props.drill}
                    drillHandle={this.props.drillHandle}
                    chartDisp={chartCat}
                    chartCat={status.chartDisp ? status.chartDisp : chartCat}
                    sortOrder={this.props.sortOrder}
                    limit={this.props.limit}
                    insightType={this.props.insightType}
                    insightMetric={this.props.insightMetric}
                    date={this.props.insightDate}
                    point={this.props.insightPoint}
                    timeHandle={this.timeHandle}
                    insightHandle={this.insightHandle}
                    downloadChart={this.downloadChart}
                    metricText={labelShow.metricText}
                    propertyText={labelShow.propertyText}
                    breakupText={labelShow.breakupText}
                    includeText={labelShow.includeText}
                    excludeText={labelShow.excludeText}
                    startDateDisp={this.props.startDateDisp}
                    endDateDisp={this.props.endDateDisp}
                    index={1}
                    handleChange={this.handleChange}
                    selectedMetricDisp={this.props.selectedMetricDisp}
                    question={this.props.question}
                    questionId={this.props.questionId}
                    metricRange={this.props.metricRange}
                    allData={this}
                    compare={this.props.compare ? this.props.compare : false}
                    summary={true}
                    dataMover={this.props.dataMover}
                    compareRank={this.props.compareRank}
                    isInsight={this.props.isInsight}
                    updateMetricRange={this.updateMetricRange}
                    // final_details={final_details}
                    // final_details_hover={final_details_hover} 
                    dashboard_config={dashboard_config}
                    pageError={this.props.pageError}
                    trend_hover_information={this.props.trend_hover_information}
                    globalFilters={this.props.globalFilters}
                    sortMetric={this.props.sortMetric}
                    cagrPoint={this.props.cagrPoint}
                    removeGlobalFilter={this.props?.removeGlobalFilter}
                    ytdcagr={this.props?.ytdcagr}
                    period = {chartType}
                    prevStartDate = {this.props?.prevStartDate}
                    prevEndDate = {this.props?.prevEndDate}
                />
            );
        } else {
            resetFilterGo();
            return <NoDataFound data={status?.message} />
        }
    }
}

function mapStateToProps(state) {
    var initial_data_from_url = {};
    initial_data_from_url = getURLDataHandle();
    let finalObj = stateToPropsHandle(initial_data_from_url, state)
    return {...finalObj, dataLabelConfig: state.dataSet?.dataLabelConfig?.dataLabelConfig, yAxis: state.dataSet?.dataLabelConfig?.yAxis , geoLocationDimesnionArray: state.dataSet.alfred.location}  //extracting location array for map chart    
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getInitialData
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ChartData);